module.exports = __webpack_public_path__ + "img/21.fd43372f.jpeg";